import {
    ApolloClient,
    createHttpLink,
    from,
    InMemoryCache
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { fingerprint } from "./common/fingerprint";
import { API_URL, APP_NAME, REVISION } from "./config";

const authLink = setContext((_, { headers }) => {
    return {
        headers: {
            ...headers,
            Authorization: `Bearer ${fingerprint()}`,
        },
    };
});

const httpLink = createHttpLink({
    uri: `${API_URL}graphql`,
    credentials: 'include',
});

const client = new ApolloClient({
    name: APP_NAME,
    version: REVISION,
    link: from([authLink, httpLink]),
    defaultOptions: {
        watchQuery: {
            errorPolicy: 'all',
            fetchPolicy: 'cache-and-network',
        },
        query: {
            errorPolicy: 'all',
        },
        mutate: {
            errorPolicy: 'all',
        },
    },
    cache: new InMemoryCache({}),
});

export default client;
